<template>
    <teleport to="body">
        <transition leave-active-class="duration-200">
            <div v-show="show" class="fixed inset-0 overflow-y-auto px-4 py-6 sm:px-0 z-50" scroll-region>
                <div v-show="show" class="fixed inset-0 transform transition-all" @click="close">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
                <div v-show="show" class="flex items-center justify-center h-screen">
                    <div class="mb-6 bg-white rounded-3xl overflow-hidden shadow-xl transform transition-all w-[420px] p-5">
                        <template v-if="! showInformation">
                            <span class="text-[18px] font-bold">Please enter your email address to book your free consultation:</span>
                            <div class="mt-2 text-center">
                                <jet-input
                                    :class="[
                                        'w-full my-3 rounded-full text-center placeholder-gray-600 bg-gray-200 focus:outline-none focus:ring-0 border-none',
                                        authUser ? 'opacity-50 cursor-not-allowed' : ''
                                    ]"
                                    for="number"
                                    type="text"
                                    placeholder="Email"
                                    v-model="formData.email"
                                    :disabled="authUser ? true : false"
                                />
                                <div v-if="errorMessage" class="mb-3">
                                    <span class="text-red-600">{{ errorMessage }}</span>
                                </div>
                                <button @click="continueAction()"
                                    :disabled="isLoading ? true : false"
                                    :class="[
                                        'custom-button w-full bg-yellow-400 text-lg shadow-md px-3 py-2 rounded-full text-white font-bold hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 flex justify-center items-center gap-3',
                                        isLoading ? 'opacity-25 cursor-not-allowed' : ''
                                    ]">
                                    <span v-if="isLoading" class="material-icons animate-spin text-gray-600 text-3xl">autorenew</span>
                                    Continue
                                </button>
                            </div>
                        </template>
                        <template v-else >
                            <span class="text-[19px] font-bold flex items-center">
                                <span class="material-icons text-green-600" style="font-size: 40px">check_circle</span>
                                <span>Your free consultation is booked!</span>
                            </span>
                            <div class="px-3 mt-2">
                                Providing the below information is <strong>optional</strong> but will help us facilitate your consultation:
                            </div>
                            <div class="mt-4 text-center">
                                <jet-input
                                    :class="[
                                        'w-full my-1 rounded-full text-center placeholder-white-600 bg-gray-200 focus:outline-none focus:ring-0 border-none',
                                        canChangeInfo ? '' : 'opacity-50 cursor-not-allowed'
                                    ]"
                                    type="text"
                                    placeholder="Name"
                                    v-model="formData.name"
                                    :disabled="canChangeInfo ? false : true"
                                />
                                <span class="mb-1 text-left text-gray-600" v-if="! canChangeInfo">Please update these details directly in your account.</span>
                                <jet-input
                                    :class="[
                                        'w-full my-1 rounded-full text-center placeholder-white-600 bg-gray-200 focus:outline-none focus:ring-0 border-none',
                                        canChangeInfo ? '' : 'opacity-50 cursor-not-allowed'
                                    ]"
                                    type="number"
                                    placeholder="Mobile number"
                                    :disabled="canChangeInfo ? false : true"
                                    v-model="formData.mobile"
                                />
                                <span class="mb-1 text-left text-gray-600" v-if="! canChangeInfo">Please update these details directly in your account.</span>
                                <jet-input
                                    :class="[
                                        'w-full my-1 rounded-full text-center placeholder-white-600 bg-gray-200 focus:outline-none focus:ring-0 border-none',
                                    ]"
                                    type="text"
                                    placeholder="City and neighborhood"
                                    v-model="formData.city"
                                />
                                <div class="mt-3 flex items-center justify-around text-[18px]">
                                    <span>
                                        Training type:
                                    </span>
                                    <div class="flex items-center gap-4">
                                        <div class="flex items-center gap-1">
                                            <input id="training_type"
                                                name="training_type"
                                                type="radio"
                                                v-model="formData.training_type"
                                                value="online"
                                                class="shadow-sm focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 border ml-2"
                                            >
                                            <span>
                                                Online
                                            </span>
                                        </div>
                                        <div class="flex items-center gap-1">
                                            <input id="training_type"
                                                name="training_type"
                                                type="radio"
                                                v-model="formData.training_type"
                                                value="in_person"
                                                class="shadow-sm focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 border ml-2"
                                            >
                                            <span>
                                                In-person
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <button @click="updateConsultation"
                                    :disabled="errorMessage || isLoading ? true : false"
                                    :class="[
                                        'custom-button w-full bg-yellow-400 text-lg shadow-md mt-3 px-3 py-2 rounded-full text-white font-bold hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 flex justify-center items-center gap-3',
                                        errorMessage || isLoading ? 'opacity-25 cursor-not-allowed' : ''
                                    ]">
                                    <span v-if="isLoading" class="material-icons animate-spin text-gray-600 text-3xl">autorenew</span>
                                    Done
                                </button>
                            </div>
                            <div v-if="errorMessage" class="mt-2 px-5 text-center text-green-600">
                                {{ errorMessage }}
                            </div>
                            <div class="px-5 mt-2 text-center">
                                Please check your inbox and spam/junk folders.
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetCheckbox from '@/Jetstream/Checkbox';

export default {
    components: {
        JetInput,JetCheckbox
    },
    emits: ['close'],
    props: {
        show: {
            default: false
        },
        master: {
            default: {},
            type: Object,
        }
    },
    data(){
        return {
            formData: {},
            showInformation: false,
            errorMessage: null,
            formData: {},
            canChangeInfo: false,
            user: {},
            authUser: null,
            isLoading: false,
        }
    },
    mounted(){
        this.authUser = this.$page.props.user;
        this.formData.email = this.authUser?.email;
    },
    methods:{
        close(){
            this.$emit('close');
            this.showInformation =false;
            this.errorMessage = null;
            this.formData = {};
            if(this.authUser){
                this.formData.email = this.authUser?.email;
            }
        },
        continueAction(){
            this.errorMessage = null;
            this.formData.master_id = this.master.id;
            this.isLoading = true;
            axios.post( route('consultation.create'), this.formData)
                .then( (res) => {
                    if(this.authUser?.email == this.formData.email){
                        this.canChangeInfo = true;
                        this.formData.name = this.authUser.first_name;
                        this.formData.mobile = this.authUser.mobile;
                    }else if(res.data.is_new_user){
                        this.canChangeInfo = true;
                    }else{
                        this.canChangeInfo = false;
                    }
                    this.user = res.data.user;
                    this.formData.consultation_id = res.data.consultation_id;
                    this.showInformation = true;
                })
                .catch( (res) => {
                    this.errorMessage = res.response?.data?.message;
                })
                .finally( () => {
                    this.isLoading = false;
                });
        },
        updateConsultation(){
            this.errorMessage = null;
            this.isLoading = true;
            axios.post( route('consultation.update'), this.formData)
                .then( (res) => {
                    this.close();
                })
                .catch( (res) => {
                    this.errorMessage = res.response.data.message;
                })
                .finally( () => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
